/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { useRouter } from 'next/router';
import { Button } from './common';
import { StatusContext } from '../contexts/statusContext';
import { disableAccount, removeToken } from '../models/user';
import { SET_CLEAR } from '../contexts/constants/userConstants';
import { UserContext } from '../contexts/userContext';
import Modal from './modals/Modal';

const DisableAccountModal = ({ t, visible, setVisible }) => {
  const { setErrorState } = useContext(StatusContext);
  const [onResponse, setOnResponse] = useState(false);
  const router = useRouter();
  const { dispatch } = useContext(UserContext);

  const onPressAccept = async () => {
    if (!onResponse) {
      try {
        await disableAccount();
        setOnResponse(true);
        await removeToken();
        await dispatch({ type: SET_CLEAR });
        await router.push('/');
      } catch (error) {
        console.log('onPressDisableAccountErr', error);
        if (error.status) {
          setVisible(false);
          setTimeout(() => {
            setErrorState({
              title: t('alert'),
              text: error.message,
              buttonText: t('close'),
              onClickButton: () => setErrorState({}),
            });
          }, 500);
        }
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered animate__animated animate__fadeInDown">
        <div className="modal-content modal-transparent">
          <div className="modal-body p-0">
            <div className="im-box im-box--white im-box--border-radius im-box--padding-30">
              <div className="row">
                <div className="col">
                  <div className="row mb-5">
                    <div className="col text-center">
                      <div className="fs-22 fw-700">Hesap Dondurma Talebi</div>
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col text-center">
                      <p className="fs-15">
                        Hesap dondurma isteğinizi onaylamanız halinde, hesabınız
                        dondurulacaktır.
                      </p>
                      <p className="fs-15">
                        Hesabınız dondurulduktan sonra sadece müşteri temsilcimiz ile
                        iletişime geçerek tekrar aktif edebilirsiniz.
                      </p>
                      <p className="fs-15">
                        Hesabınızı dondurmayı onaylıyor musunuz?
                      </p>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col text-center">
                      <Button
                        className="im-button im-button--outline-yellow2 im-button--size-60 im-button--center fw-900 col-15 mt-1"
                        label="Hayır, Onaylamıyorum"
                        onClick={() => setVisible(false)}
                      />
                    </div>
                    <div className="col text-center">
                      <Button
                        className="im-button im-button--primary im-button--size-60 im-button--center fw-900 col-15 mt-1"
                        label="Evet, Onaylıyorum"
                        loading={onResponse}
                        onClick={onPressAccept}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

DisableAccountModal.propTypes = {
  t: PropTypes.func,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
};

export default DisableAccountModal;
